// OrdersPage.js
import React from 'react';

// A simple React component that displays a heading.
const Support = () => {
  return (
    <div>
      <h3>💬 Support Page</h3>
    </div>
  );
};

export default Support;
